export const API_BASE_URL='https://quickboard-2efo.onrender.com/api';